var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-user"},[_c('AliareInput',{attrs:{"labelText":"Pesquisar um Usuário"},model:{value:(_vm.userInput),callback:function ($$v) {_vm.userInput=$$v},expression:"userInput"}}),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }